<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <h1 class="title mb-3">My Meetings</h1>
        <div class="row">
          <div class="col-6">
            <span class="result-Text">
              {{ pageStart }} - {{ pageEnd }} of {{ total }}
            </span>
          </div>
          <NCD searchKey="date" label="Meeting Date"/>
        </div>
        <div class="card">
        <div class="card-body p-3 card-message" v-if="meetings.length === 0">
          <img src="@/assets/message-icon.svg" alt="" />
          <span class="info">No meetings</span>
        </div>
        <router-link
          :to="{ name: 'MeetingDetails', params: { id: meeting.uuid } }"
          tag="div"
          class="card-body p-3"
          v-else v-for="(meeting, index) in meetings"
          :key="index"
        >
          <div class="">
            <div class="row">
              <div class="col-7 pr-0 mt-1">
                <h3 class="broker-name">{{meeting.name}}</h3>
                <span class="firm-name">{{meeting.firm_name}}</span>
                 <span class="mt-2 emp-Name" v-if="meeting.user_full_name"> {{meeting.user_full_name}} </span>
              </div>
              <div class="col-5 pl-0 text-right">
                   <span class="label-status-sm"> {{meeting.lead_status_name}} </span>
                <span class="date">
                  <i class="icon-calender">
                    <img src="@/assets/calender.svg" alt="" />
                  </i>
                  {{meeting.meeting_date}}
                  <i class="icon-arrowr">
                    <img src="@/assets/right-arrow.svg" alt="" />
                  </i>
                </span>
              </div>
            </div>
          </div>
        </router-link>
        </div>
      </b-container>
      <paginate v-if="totalPages > 1"
        v-model="pageNo"
        :page-count="totalPages"
        :click-handler="goToPage"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :prev-class="'page-item'"
        :prev-link-class="'page-link'"
        :next-class="'page-item'"
        :next-link-class="'page-link'"
        :container-class="'pagination justify-content-center'"
        :page-class="'page-item'"
        :page-link-class="'page-link'">
      </paginate>
    </div>
  </div>
</template>
<script>
import { paramsFromQuery, MEETING_SCHEDULED } from "@/assets/scripts/utility.js";
import qs from "qs";
import NCD from '@/components/Common/Ncd.vue'

export default {
  components: {
    NCD
  },
  name: "PastUpcomingMeeting",
  data() {
    return {
      total: 0,
      perPage: 0,
      meetings: [],
      startDateOutput: null,
      endDateOutput: null
    };
  },
  computed: {
    customDefault(){
      return this.$store.getters.customDefault;
    },
    totalPages(){
      if(this.total === 0 || this.perPage === 0){
        return 0;
      }else{
        return Math.ceil(this.total/this.perPage);
      }
    },
    pageNo: {
      get(){
        let pageNo = this.$route.query.pageNo || 1
        return parseInt(pageNo);
      },
      set(){
        true;
      }
    },
    pageStart(){
      if(this.total === 0){
        return 0;
      }
      return (Math.max(0, (this.pageNo - 1)*this.perPage+1))
    },
    pageEnd(){
      if(this.total === 0){
        return 0;
      }
      return (Math.min(this.total, this.pageNo*this.perPage))
    }
  },
  created(){
    this.loadData();
  },
  watch: {
    $route(to, from) {
      this.loadData();
    },
  },
  methods: {
    loadData(){
      let is_past = this.$route.params.meeting_type === 'past' ? true : false
      this.meetings = []
      let queryP = {};
      paramsFromQuery(queryP, this.$route.query);
      let dateTo;
      let dateFrom;
      let searchDataUrl;
      let url;
      let startDateOutput;
      let endDateOutput;
      if(is_past){
        endDateOutput = this.$moment().subtract(this.customDefault.start,'d').format('YYYY-MM-DD');
        searchDataUrl = new URLSearchParams({meeting_upto: endDateOutput}).toString();
      }
      else{
        startDateOutput = this.$moment().subtract(this.customDefault.end,'d').format('YYYY-MM-DD');
        searchDataUrl = new URLSearchParams({meeting_from: startDateOutput, status_id: MEETING_SCHEDULED}).toString();
      }
      url = `meetings?${searchDataUrl}`
      this.$axios.get(url, {
        params: queryP,
        paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "brackets" }),
      })
      .then(res => {
        this.meetings = res.data.meetings;
        this.perPage = res.data.per_page;
        this.total = res.data.count;
        console.log(this.total);
      })
      .catch(err => console.log(err));
    },
    goToPage(pageNo){
      let newQ = {...this.$route.query, pageNo};
      this.$router.replace({query: newQ});
    }
  }
};
</script>
<style scoped>
.filterDate {
  margin-top: -5px;
}
</style>